const getUser = () => {
  const user = localStorage.getItem("user");
  return user ? JSON.parse(user) : {};
};

export const teamHasDialler = (checkUserKind = true, user = null) => {
  user = user || getUser();
  return (
    !(checkUserKind && user.kind === "viewer") &&
    ["standard", "unlimited"].includes(user.diallerPlan)
  );
};

/**
 * @param {any} user
 * @param { "ausConversations"
 *   | "euConversations"
 *   | "ukConversations"
 *   | "usConversations"
 *   | "data"
 *   | "dataRefresh"
 *   | "inboxAgent"
 *   | "outreach"
 *   | "notetaker"} kind
 */
export const hasLicense = (user, kind, allowViewer = false) => {
  if (!user.licenseDict) return true;
  const license = user.licenseDict[kind];
  const userIsViewer = user.kind === "viewer" || user.isOnAnotherTeam;
  return (
    license &&
    ["active", "trial"].includes(license.status) &&
    (allowViewer || !userIsViewer)
  );
};

export const conversationsLicenses = [
  "ausConversations",
  "euConversations",
  "ukConversations",
  "usConversations",
];

/**
 * @param {any} user
 */
export const hasConversationsLicense = (user) =>
  conversationsLicenses.some((kind) => hasLicense(user, kind));
